import React, { useEffect, useCallback } from "react";

export const useClickOutside = (
  ref: React.RefObject<any>,
  callback: () => void,
  secondRef?: React.RefObject<any>
) => {
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const eventTarget = event.target as Node;
      const isClickOutside =
        (ref.current &&
          !ref.current.contains(eventTarget) &&
          !secondRef?.current) ||
        (ref.current &&
          !ref.current.contains(eventTarget) &&
          secondRef?.current &&
          !secondRef?.current.contains(eventTarget));

      if (isClickOutside) {
        callback();
      }
    },
    [ref, secondRef, callback]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);
};
